var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Card",on:{"click":function($event){return _vm.$router.push({ name: _vm.info.path })}}},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.info.text)+" ")])]),_c('div',{staticClass:"right",style:({
      backgroundImage: ("url(" + (_vm.info.background.image) + ")"),
      backgroundSize: _vm.info.background.size,
      backgroundPosition: _vm.info.background.position,
    })},[_c('div',{staticClass:"circle"})])])}
var staticRenderFns = []

export { render, staticRenderFns }